import type { LegacyNoteSchema } from '@libs/data-access/entities'
import { Modal, PencilWriteIcon } from '@libs/ui/ds'
import {
  usePlanningFormTranslation,
  useCommonAppTranslation
} from '@libs/utils/translations'
import { FieldDraftEditor } from '@spa/components'
import moment from 'moment'
import React, { useCallback, useState } from 'react'
import type { FC } from 'react'

import isEmptyAfterHTMLClean from './utils/isEmptyAfterHTMLClean'

type NoteFormProps = {
  onSubmit: Function
  onClose?: () => void
  note?: LegacyNoteSchema
}

type ActionsButtonsProps = {
  noteId?: number
  onNoteDelete?: Function
  disabled?: boolean
}
export const ActionsButtons: FC<ActionsButtonsProps> = ({
  noteId,
  onNoteDelete,
  disabled = false
}) => {
  const { t } = useCommonAppTranslation()

  if (!noteId) {
    return (
      <Modal.Footer.Success disabled={disabled} type='submit'>
        {t('action.add')}
      </Modal.Footer.Success>
    )
  }

  return (
    <>
      <Modal.Footer.Danger
        onClick={() => onNoteDelete && onNoteDelete(noteId)}
        data-testid='button-delete-note'
      >
        {t('action.delete')}
      </Modal.Footer.Danger>

      <Modal.Footer.Success type='submit' disabled={disabled}>
        {t('action.save')}
      </Modal.Footer.Success>
    </>
  )
}

/**
 * @deprecated
 */
const NoteFormLegacy: FC<NoteFormProps & ActionsButtonsProps> = ({
  onSubmit,
  note,
  ...other
}) => {
  const [currentNote, setCurrentNote] = useState(note?.note || null)
  const { t } = usePlanningFormTranslation()
  const formattedDate = note?.date && moment(note.date).format('LL')

  const onChange = newNote => {
    // The newValue here is a string compacted with HTML (ex: <p></p> -> empty)
    setCurrentNote(newNote)
  }

  const handleSubmit = useCallback(
    event => {
      event.preventDefault()

      onSubmit(note, { note: currentNote })
    },
    [onSubmit, note, currentNote]
  )

  return (
    <form onSubmit={handleSubmit}>
      <Modal.Header
        title={t('noteForm.title')}
        desc={formattedDate}
        leftIcon={<PencilWriteIcon />}
      />
      <Modal.Content>
        <FieldDraftEditor
          autofocus
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          input={{ name: 'note', value: currentNote, onChange }}
          displayLink
          displayBlockStyle={false}
        />
      </Modal.Content>
      <Modal.Footer>
        <ActionsButtons
          noteId={note?.id}
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          disabled={isEmptyAfterHTMLClean(currentNote)}
          {...other}
        />
      </Modal.Footer>
    </form>
  )
}
export default NoteFormLegacy
